import { HttpContextToken } from '@angular/common/http';

/**
 * Omite alertas globales cuando una consulta auxiliar admite una degradacion controlada.
 * Los errores de autenticacion (401) siempre conservan el manejo global.
 */
export const SKIP_GLOBAL_ERROR_ALERT = new HttpContextToken<boolean>(() => false);
